// export const PATH_PROFILE = "http://192.168.100.28:4000/profile/"
// export const PATH_IMAGE = "http://192.168.0.159:4000/cdn/"
// export const PATH_IMAGE = "http://161.97.74.52/cdn/"
export const PATH_IMAGE = "http://localhost:4000/cdn/"
